import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { DocumentContributorCollection } from '../index'

export const setupDocumentContributorReplication = (
  collection: DocumentContributorCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'documentcontributors',
    displayName: 'DocumentContributors',
    collection,
    envId,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      documentId: doc.documentId,
      userId: doc.userId,
      isDeleted: doc.isDeleted || false,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy ?? null,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      documentId: state.documentId,
      userId: state.userId,
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn ?? null),
      deletedBy: state.deletedBy ?? null,
    }),
  })
